import { deviceHasTouch } from '../../../utils/device-has-touch';
export const getGliderSettings = (settings, touchSettings) => {
    const hasTouch = deviceHasTouch();
    if (!hasTouch)
        return settings;
    return Object.assign(Object.assign({}, settings), touchSettings);
};
